// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const periodo = new Date().getFullYear().toString();
// export const environment = {
//   production: false,
//   url: "https://demo-sigcom.devscon.app/",
//   apiUrl: "https://devscon.net.pe/demo/sigcom/api-ecm",
//   apiUrlAdm: "https://devscon.net.pe/demo/sigcom/api-admin",
//   apiUrlTeso: "https://devscon.net.pe/demo/sigcom/api-tesoreria",
//   apiUrlTablas: "https://devscon.net.pe/demo/sigcom/api-tablas",
//   apiUrlVentas: "https://devscon.net.pe/demo/sigcom/api-ventas",
//   apiUrlLogis: "https://devscon.net.pe/demo/sigcom/api-logistica",
//   urlInfoQuery: "https://devscon.nom.pe/cip",
//   apiCulqi: "https://novaplaza.nom.pe/api/ccargo",
//   apiUrl2: "https://novaplaza.nom.pe/infoquery",
//   imgGerenica: "https://www.novaplaza.pe/img/marcas/genericos.png",
//   direccionEntrega: "Calle Octavio Muñoz Najar 221 int 211 Arequipa - Arequipa",
//   minTiempoEntrega: "15",
//   anioPeriodo: periodo,
//   ubigeoLocal: "040101",
// };
export const environment = {
  production: false,
  url: "https://novaplaza.devscon.pe/",
  apiUrl: "https://devscon.nom.pe/novaplaza/api-ecm",
  apiUrlAdm: "https://devscon.nom.pe/novaplaza/api-admin",
  apiUrlTeso: "https://devscon.nom.pe/novaplaza/api-tesoreria",
  apiUrlTablas: "https://devscon.nom.pe/novaplaza/api-tablas",
  apiUrlVentas: "https://devscon.nom.pe/novaplaza/api-ventas",
  apiUrlLogis: "https://devscon.nom.pe/novaplaza/api-logistica",
  urlInfoQuery: "https://devscon.nom.pe/cip",
  apiCulqi: "https://novaplaza.nom.pe/api/ccargo",
  apiUrl2: "https://novaplaza.nom.pe/infoquery",
  imgGerenica: "https://www.novaplaza.pe/img/marcas/genericos.png",
  direccionEntrega: "Calle Octavio Muñoz Najar 221 int 211 Arequipa - Arequipa",
  minTiempoEntrega: "15",
  anioPeriodo: periodo,
  ubigeoLocal: "040101",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
